import React from 'react';

import Panel from 'components/Toolbar/Shared/Panel';
import { ProjectMetadataMap } from 'const/ProjectMetadata';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

interface TokenProps {
  dataTestId?: string;
  addToken: (token: string) => void;
  isOpen: boolean;
  onToggle: () => void;
}

const Token: React.FunctionComponent<TokenProps> = (props) => {
  const { dataTestId = 'token-panel', addToken, isOpen, onToggle } = props;

  return (
    <Panel
      title={intlGet('EditorToolbar.Token', 'Title')}
      isOpen={isOpen}
      onClose={onToggle}
      dataTestId={`${dataTestId}-container`}
    >
      <div className={styles.description}>{intlGet('EditorToolbar.Token', 'Description')}</div>
      {Object.values(ProjectMetadataMap).map(metadata => (
        <div
          key={metadata.key}
          role="button"
          className={styles.item}
          onClick={addToken.bind(null, metadata.title)}
          tabIndex={0}
          onKeyDown={(e): void => {
            if (e.key === 'Enter' || e.key === ' ') {
              addToken(metadata.title);
              e.preventDefault();
              e.stopPropagation();
            }
          }}
          data-testid={`${dataTestId}-item`}>
          <span className={styles.name}>&#123;&#123;{metadata.title}&#125;&#125;&nbsp;</span>
          <span className={styles.description} data-testid={`${dataTestId}-description`}>
            - {metadata.description}
          </span>
        </div>
      ))}
    </Panel>
  );
};

export default Token;
